// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3T3dj","badges":"styles_badges__2aQrL"};